import React, { useEffect, useState } from "react";
import { Buffer } from "buffer";
import Profile from "../components/profile/profileInClient";
// Import skelton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// Import supabase configuration
import supabase from "../config/supabase";

function Client() {
  const [profiles, setProfiles] = useState([]);
  const [boardId, setBoardId] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [loading, setLoading] = useState(true);  
  useEffect( async() => {
    document.title = "Client View";
    var url = new URL(window.location.href);
    var board_id = url.searchParams.get("id");
    var boardId = Buffer.from(board_id || "", "base64").toString("utf-8");
    setBoardId(boardId);

    await getBoardProfiles(boardId);
     // loggedIn && setShowSignup(true);
     setTimeout(() => {
      setLoading(false);
    }, 1200);
  }, []);
  const getBoardProfiles = async (id) => {
    
    var { data, error } = await supabase
    .from("board_profiles")
    .select("*")
    .match({ board: id });
    
    if (data && data.length) {

      var profiles =
      data[0].profiles
        ? await getAllProfiles(data[0].profiles)
        : [];
    } 

    profiles?.map(async (index) => {
      if (index.emoji_dp) {
        // get url for dp
        const { signedUrl, data, error } = await supabase.storage
        .from("data")
        .createSignedUrl(index.emoji_dp, 600);
        if (data) {
          // set url
          // setUrl(data["signedURL"]);
          index.url = data["signedURL"];
        }
      } else {
        // setUrl("/avatar.png");
        index.url = "/avatar.png";
      }
    });

    setProfiles(profiles);
    setShowLoader(false);
  };

  const getAllProfiles = async (ids) => {
    var all_profiles = [];
    for (var i = 0; i < ids.length; i++) {
      const { data, error } = await supabase
        .from("all_profiles")
        .select("*")
        .match({ id: ids[i].id });
      var profile = { ...data[0], status: ids[i].status };
      all_profiles.push(profile);
    }
    return all_profiles;
  };
  let skeletonRepeated = 3;

  return (

    <>
    <div className={`w-full bg-blue-1 ${(profiles.length >= 3 || showLoader) ? "h-full" : "h-screen"} `} >
        {/* Show profiles */}
        <div className="col-span-12 p-6">
        {showLoader ? (
            [...Array(skeletonRepeated)].map((e , index) => (
            <div className="-z-10 rounded bg-white-1 shadow-clientCard h-50 grid grid-cols-12 gap-3 p-4 box-border mx-4 mb-5" key={index}>
                <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex mt-5 relative">
                <Skeleton height={90} width={90} />
                </div>
                <div  className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-3 pl-5">
                {/*For name and email */}
                <div className="col-span-12">
                    <Skeleton height={23} width={150} />
                </div>
                {/* For location */}
                <div className="col-span-12 lg:col-span-5">
                    {/* hourly rate */}
                    <div className="flex items-center">
                    <Skeleton height={23} width={92} className="mr-1" />
                    </div>
                </div>
                {/* For timezone */}
                <div className="col-span-12 lg:col-span-4">
                    {/* hourly rate */}
                    <div className="flex items-center">
                    <Skeleton height={23} width={92} className="mr-1" />
                    </div>
                </div>
                {/* For experience */}
                <div className="col-span-12 lg:col-span-5">
                    {/* experience label */}
                    <div className=" flex items-center">
                    <Skeleton height={18} width={92} className="mr-1" />
                    </div>
                    {/* experience */}
                    <div className="flex items-center">
                    <Skeleton height={23} width={92} className="mr-1" />
                    </div>
                </div>
                {/* For hourly rate */}
                <div className="col-span-12 lg:col-span-4">
                    {/* hourlyRate label */}
                    <div className="flex items-center">
                    <Skeleton height={18} width={92} className="mr-1" />
                    </div>
                    {/* hourly rate */}
                    <div className="flex items-center">
                    <Skeleton height={23} width={92} className="mr-1" />
                    </div>
                </div>
                {/* <div className="hidden md:block col-span-2"></div> */}
                {/* For Skills */}
                <div className="col-span-12 md:col-span-10 flex flex-wrap">
                    <div className="">
                    <Skeleton height={30} width={350} />
                    </div>
                </div>
                </div>
            </div>
            ))
            ):
        profiles.length > 0 && (profiles.length >= 3 ?
            profiles.slice(0,3).map((data, index) => (
                <div key={index} className="col-span-12 md:col-span-3 pb-7">
            
                <Profile
                    profile={data}
                    />
                </div>
            ) ) : 
            profiles.map((data, index) => (
            <div key={index} className="col-span-12 md:col-span-3 pb-7">
            
                <Profile
                profile={data}
                />
            </div>
        ) )) 
        }
        </div>
    </div>
    </>
  );
}
export default Client;
